import React from 'react';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { LzTAvatarSizes } from '@lz/typings';

export interface LzPMedia {
  isAvatar?: boolean;
  avatarInitials?: string;
  avatarSize?: LzTAvatarSizes;
  altText?: string;
  imgSrc?: string;
  label?: string;
  className?: string;
  onRemove?: () => void;
  onUpload?: () => void;
}

const LzXMedia = (props: LzPMedia) => {
  const hasMedia = props.imgSrc && props.imgSrc !== '';

  let avatarSize = 36;
  let avatarClassName = props.className || '';
  if (typeof props.avatarSize != 'undefined') {
    if (props.avatarSize === 'tiny') {
      avatarSize = 24;
      avatarClassName += ' lz-avatar-tiny';
    } else if (props.avatarSize === 'small') {
      avatarSize = 36;
      avatarClassName += ' lz-avatar-small';
    } else if (props.avatarSize === 'medium') {
      avatarSize = 56;
      avatarClassName += ' lz-avatar-medium';
    } else if (props.avatarSize === 'large') {
      avatarSize = 72;
      avatarClassName += ' lz-avatar-large';
    } else {
      avatarSize = +props.avatarSize;
    }
  }

  return (
    <div style={{ width: 'fit-content', position: 'relative' }}>
      <InputLabel className='lz-label' shrink>
        {props.label}
      </InputLabel>

      {hasMedia && props.onRemove && (
        <IconButton
          size='small'
          className='lz-color-error'
          style={{
            width: 24,
            height: 24,
            position: 'absolute',
            top: 8,
            right: -6,
            zIndex: 99,
          }}
          onClick={props.onRemove}
        >
          <RemoveIcon />
        </IconButton>
      )}

      {props.onUpload && (
        <IconButton
          size='small'
          className='lz-color-success'
          style={{
            width: 24,
            height: 24,
            position: 'absolute',
            bottom: -8,
            right: -6,
            zIndex: 99,
          }}
          onClick={props.onUpload}
        >
          {hasMedia ? <EditIcon style={{ fontSize: 16 }} /> : <AddIcon />}
        </IconButton>
      )}

      {props.isAvatar ? (
        <Avatar
          src={props.imgSrc}
          alt={props.altText}
          children={props.avatarInitials}
          sx={{
            width: avatarSize,
            height: avatarSize,
            fontSize: avatarSize / 2.6,
          }}
          className={avatarClassName}
        />
      ) : (
        <Card elevation={0} className={props.className || ''}>
          <CardMedia image={props.imgSrc} title={props.altText} />
        </Card>
      )}
    </div>
  );
};

export default LzXMedia;
